var $5b886be0f3fc6f0a$exports = {};
$5b886be0f3fc6f0a$exports = {
    "loading": `Indl\xe6ser ...`,
    "loadingMore": `Indl\xe6ser flere ...`
};


export {$5b886be0f3fc6f0a$exports as default};
//# sourceMappingURL=da-DK.mjs.map
